import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { setRelevanceGroup, toggleTimelineActive, toggleRelevanceChart } from '../../actions/dataAction';
import moment from 'moment';
import styled from 'styled-components';
import {Line} from 'react-chartjs-2';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import {Box, BoxButton, MainHeading} from '../StyledComponents';
import Loading from '../Loading.js';
import MediaQuery from 'react-responsive';
import Media from "react-media";
import IconButton from 'material-ui/IconButton';
import ImageTune from 'material-ui/svg-icons/image/tune';
import ToggleCheckBoxOutlineBlank from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import ToggleCheckBox from 'material-ui/svg-icons/toggle/check-box';


/**
* Colors
*/
//const themeColors = ['#5ab99a', '#fa7823', '#b21fd1', '#0e67b9', '#9674a0', '#d26565', '#7b4172', '#e7969c', '#a55094', '#843c39'];
const themeColors = [
  "#f49e6d",
  "#b9b84c",
  "#fd7923",
  "#daa8e3",
  "#a6050e",
  "#ee5a5d",
  "#9edfa6",
  "#aed4fd"
];

/**
* Styled components
*/
const RelevanceViewContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 991px) {
    min-height: 500px;
  }

  @media only screen and (max-width: 524px) {
    min-height: 450px;
  }
`;

const ChartDescription = styled.h4`
  text-align: center;
  color: #929698;
  padding-left: 20%;
  padding-right: 20%;
  margin-bottom: 30px;

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const SmallerRow = styled.div`
  padding-left: 5%;
  padding-right: 5%;

  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ChartDataContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 40px 0;
`;

const DataContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-bottom: 20px;

  @media print {
    -webkit-print-color-adjust: exact;
  }
`;

const DataInnerContainer = styled.div`
  width: 50%;
`;

const IconRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const IconData = styled.span`
  margin-right: 5px;
  height: 12px;
  width: 12px;
  border-radius: 50% !important;
  display: inline-block;
`;

const TitleData = styled.p`
  color: #c3c3c3;
  margin-bottom: 0;
  line-height: 12px;
`;

const InfoContainer = styled.div`
  display: flex;

  @media only screen and (max-width: 524px) {
    flex-direction: column;
  }
`;

const OptionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 15px;
  padding-bottom: 10px;
  padding-right: 0;
  padding-left: 0;

  @media only screen and (max-width: 524px) {
    margin-bottom: 0;
  }
`;

const InnerOptionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
`;

const ChartContainer = styled.div`
  flex: 1;

  @media print {
    min-height: 200px;
  }
`;

const LineChartPopover = styled(Popover)`
  border-radius: 3px !important;
`;

const LineChartMenu = styled(Menu)`
  background-color: #fff !important;
  color: #333 !important;

  > div > span {
    font-size: 12px !important;
    min-height: 26px !important;

    > div {
      line-height: 26px !important;
      > div {
        padding: 0 2px 0 32px !important;
        > svg {
          margin: 5px 8px !important;
          height: 16px !important;
          width: 16px !important;
        }

        > div {
          color: rgba(0, 0, 0, 0.87) !important;
        }
      }
    }
  }
`;

const IconTuneButton = styled(IconButton)`
  padding: 0 !important;
  height: 24px !important;
  width: 24px !important;
  margin-right: 15px !important;
`;

/**
* Class RelevanceChartView
*/

class RelevanceChartView extends Component {

  constructor(props) {
    super(props)

    this.state = {
      firstPopoverOpen: false,
      secondPopoverOpen: false,
    };

    this.handleXChart = this.handleXChart.bind(this);
  }

  monthsDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();

    return months <= 0 ? 0 : months;
  }

  translateData(data, group) {
    if (_.isEmpty(data)) {
      return {};
    };

    let values = data;

    if (typeof values === 'string' || values instanceof String) {
      values = JSON.parse(data);
    };

    const datapoints = [
      {id: "prc", label:"Price", color:themeColors[0]},
      {id: "prd", label:"Product", color:themeColors[1]},
      {id: "prm", label:"Promotion", color:themeColors[2]},
      {id: "prp", label:"Perception", color:themeColors[3]},
      {id: "ppl", label:"People", color:themeColors[4]},
      {id: "prf", label:"Preference", color:themeColors[5]},
      {id: "rlv", label:"Relevance", color:themeColors[6]}
    ];

    let datasets = [];
    let labels = [];

    _.forEach(values, function(val) {
      switch (group) {
        case 'month':
            labels.push(moment(val.date).format('MMMM -YY'));
          break;
        case 'quarter':
            labels.push("Q" + moment(val.date).quarter() + " -" + moment(val.date).format("YY"));
          break;
        default:
            labels.push("Q" + moment(val.date).quarter() + " -" + moment(val.date).format("YY"));
          break;
      }
    });

    // Build datasets
    _.forEach(datapoints, function(datapoint, i) {
      let chartValues = [];
      _.forEach(values, function(val) {
        if (val.hasOwnProperty(datapoint.id)) {
          //chartValues.push(parseFloat(val[datapoint.id]).toFixed(2));
          chartValues.push(parseFloat(val[datapoint.id].score).toFixed(2));
        };
      });

      const dataset = {
        data: chartValues,
        label: datapoints[i].label,
        color: datapoint.color,
        yAxisID: "A",
        borderColor: datapoint.color, //i
        pointBorderColor: datapoint.color, //i
        pointBackgroundColor: datapoint.color, //i
        fill: false,
      };

      datasets.push(dataset);
    });

    // Add subscriptions
    let clientViewSettings = (this.props.user.client && this.props.user.client.viewSettings) || {};
    if (clientViewSettings && clientViewSettings.newSubscriptions) {
      const rawData = this.props.rawData || {};
      const subs = rawData.newSubscriptions;
      let subsValues = [];

      const startYear = rawData.startDate && new Date(rawData.startDate).getFullYear();
      const endYear = rawData.endDate && new Date(rawData.endDate).getFullYear();
      const startMonth = rawData.startDate && new Date(rawData.startDate).getMonth() + 1;
      const endMonth = rawData.endDate && new Date(rawData.endDate).getMonth() + 1;

      let firstAvailableYear = 10000;
      let firstAvailableMonth = 1000;
      let firstAvailableDate;
      let emptyMonths = 0;
      for (var year in subs) {
        if (subs.hasOwnProperty(year) && year < firstAvailableYear) {
          firstAvailableYear = year;
        }
      }

      for (var month=13;month>0;month--) {
        if (subs[firstAvailableYear] && subs[firstAvailableYear][month] && month < firstAvailableMonth){
          firstAvailableMonth = month;
          if (firstAvailableMonth.toString().length===1) {
            firstAvailableMonth = "0".concat(firstAvailableMonth);
          }
        }
      }

      firstAvailableDate = firstAvailableYear+"-"+firstAvailableMonth+"-01";
      emptyMonths = this.monthsDiff(new Date(rawData.startDate), new Date(firstAvailableDate));

      if (emptyMonths > 0) {
        for (var i=0;i<emptyMonths+1;i++) {
          subsValues.push(null);
        }
      }

      for (var year in subs) {
        if (subs.hasOwnProperty(year)) {
            if (year >= startYear && year<= endYear) {

              let yearData = subs[year];

              for (var month=1;month<13;month++) {
                if (year === startYear && month < startMonth) {
                  continue;
                } else if (year === endYear && month > endMonth) {
                  continue;
                } else if (yearData[month]){
                  subsValues.push(yearData[month]);
                }
              }
            }

        }
      }

      const color = "#a62ac2";
      const subsDataset = {
        data: subsValues,
        label: "New subscriptions",
        color: color,
        yAxisID: "B",
        borderColor: color, //i
        pointBorderColor: color, //i
        pointBackgroundColor: color, //i
        fill: false,
      };
      datasets.push(subsDataset);
    }

    const dataOut = {
      labels: labels,
      datasets: datasets
    }
    return dataOut;
  }


  renderChartLegend(data) {
    let values = data.datasets;
    let inactiveVars = this.state && this.state.inactiveVars ? this.state.inactiveVars : [];

    return _.map(values, (dataValue, key) => {
      if (inactiveVars.indexOf(dataValue.label) > -1) {
        return false;
      };
      return (
        <DataInnerContainer key={key}>
          <IconRow>
            <IconData style={{backgroundColor: dataValue.color}}></IconData>
            <TitleData className="small-font-size">{dataValue.label}</TitleData>
          </IconRow>
        </DataInnerContainer>
      );
    });
  }

  handleClick = (name ,event) => {
    event.preventDefault();

    this.setState({
      [name]: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = (name) => {
    this.setState({
      [name]: false,
    });
  };

  handleXChart(event, value) {
    this.props.setRelevanceGroup(value.toLowerCase());
  }

  toggleVariableActive(value) {
    let inactiveVars = this.state && this.state.inactiveVars ? this.state.inactiveVars : [];
    if (inactiveVars.indexOf(value) > -1) {
      inactiveVars.splice(inactiveVars.indexOf(value), 1);
    } else {
      inactiveVars.push(value);
    }
    this.setState({inactiveVars: inactiveVars});
  }

  renderVariableToggleMenuItems(data) {
    const _this = this;
    let inactiveVars = this.state && this.state.inactiveVars ? this.state.inactiveVars : [];

    let menuItems = [];
    _.forEach(data.datasets, function(obj, i) {
      const isInactive = (inactiveVars.indexOf(obj.label) > -1);
      menuItems.push(<MenuItem key={i+obj.label} primaryText={obj.label} value={obj.label} onClick={() => _this.toggleVariableActive(obj.label)} leftIcon={isInactive ? <ToggleCheckBoxOutlineBlank />:<ToggleCheckBox />} />);
    });

    return (
        <LineChartMenu multiple={true}>
          {menuItems}
        </LineChartMenu>
    );
  }

  skipInactiveVars(data) {
    let datasets = data.datasets || [];
    let inactiveVars = this.state && this.state.inactiveVars ? this.state.inactiveVars : [];
    let disabled = this.props.user && this.props.user.userProfile && this.props.user.userProfile.disabledParams;

    inactiveVars.push(disabled)

    _.remove(datasets, function (el) {
      return (inactiveVars.indexOf(el.label) > -1);
    });

    data.datasets = datasets;

    return data;
  }

  timelineActive() {
      return process.env.REACT_APP_TIMELINE_ACTIVE === "true";
  }

  render() {
      const { rawData } = this.props;
      if (!rawData.relevanceData) {
        return <Box><Loading fullHeight={true}/></Box>;
      }

      const group = rawData.relevanceGroup;

      //const groupData = rawData.relevanceData[group] || {};
      const groupData = rawData.relevanceData.data;

      const data = groupData || {};
      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              id: "B",
              position: 'right',
              ticks: {
                //max: 20000,
                //min: 0
              }
            },
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                fontColor: '#fff',
                fontSize: 10,
                //max: 10,
                //min: -10
              },
              gridLines: {
                color: '#333333',
                zeroLineColor: '#333',
                lineWidth: 0.5,
              }
            }
          ],
          xAxes: [{
            display: true,
            ticks: {
              fontColor: '#fff',
              fontSize: 10,
            }
          }]
        },
        elements: {
          line: {
            tension: 0,
            borderWidth: 1,
          }
        },
        animation: {
          duration:0
        }
      }

      const chartData = this.translateData(data, group);
      return (
          <Box>
            <RelevanceViewContainer>
                <MainHeading>Relevance</MainHeading>

              <ChartDescription style={data.description ? {} : {display: 'none'}}>{data.description ? data.description : ''}</ChartDescription>

              <ChartDataContainer className="row">
                <SmallerRow>
                  <InfoContainer>
                    <DataContainer className="col-xs-12 col-sm-5 col-md-5">
                      {this.renderChartLegend(chartData)}
                    </DataContainer>
                    <OptionContainer className="col-xs-12 col-sm-7 col-md-7">

                      <InnerOptionContainer>
                        <BoxButton onClick={() => this.props.toggleRelevanceChart(false)} className="margin-left hidden-xs" primary>
                          <span>KPI Pyramid</span>
                        </BoxButton>

                        {this.timelineActive() && (
                          <BoxButton onClick={() => this.props.toggleTimelineActive(this.props.rawData.timelineActive ? false:true)} className="margin-right hidden-xs">
                            <span>{moment(rawData.startDate).format("YYYY-MM-DD")} - {moment(rawData.endDate).format("YYYY-MM-DD")}</span>
                          </BoxButton>
                        )}

                        <IconTuneButton onClick={this.handleClick.bind(this, 'secondPopoverOpen')}>
                          <ImageTune color="#efefef" />
                        </IconTuneButton>
                        <LineChartPopover
                          open={this.state.secondPopoverOpen}
                          anchorEl={this.state.anchorEl}
                          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                          targetOrigin={{horizontal: 'right', vertical: 'top'}}
                          onRequestClose={this.handleRequestClose.bind(this, 'secondPopoverOpen')}
                        >

                            {this.renderVariableToggleMenuItems(chartData)}

                        </LineChartPopover>

                      </InnerOptionContainer>

                    </OptionContainer>
                  </InfoContainer>
                </SmallerRow>

                <ChartContainer className="col-xs-12 col-sm-12 col-md-12">
                  <Line data={this.skipInactiveVars(chartData)} options={chartOptions} />
                </ChartContainer>

              </ChartDataContainer>

            </RelevanceViewContainer>
          </Box>
      );

  }
}

function mapStateToProps(state, ownProps) {
    return {
      rawData: state.data,
      uid: state.user.uid,
      user: state.user
    };
}

export default connect(mapStateToProps, { setRelevanceGroup, toggleTimelineActive, toggleRelevanceChart })(RelevanceChartView);



// WEBPACK FOOTER //
// ./src/components/dataViews/RelevanceView.js